import { isErrorWithMessage } from "@/models/helper/ErrorWithMessage";
import { UserFacingError } from "@/models/helper/UserFacingError";
import { ITeamMember } from "@/models/user/TeamMember";
import axios from "axios";

export default class UserService {
  static async fetchBorrowerData(credentials: string[]): Promise<{
    successful: ITeamMember[];
    failed: { credential: string; reason: string }[];
  }> {
    try {
      const res = await axios.post(
        `${import.meta.env.VITE_API_URL}user/borrower-data`,
        {
          credential: credentials,
        }
      );
      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Failed to fetch borrower data.",
        logMessage: isErrorWithMessage(error)
          ? error.message
          : "An unknown error occured.",
      });
    }
  }

  static async getName(credential: string): Promise<string> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + `user/get-name?credential=${credential}`
      );
      return res.data.data;
    } catch (error) {
      console.error(`Failed to fetch name for ${credential}`, error);
      return credential;
    }
  }
}
